//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Carousel, Slide } from "vue-carousel";
import { getProducts, getTranslations } from "../services/product";
import ProductCard from "./ProductCard.vue";

export default {
  name: "ProductCardsCarousel",
  components: {
    Carousel,
    Slide,
    ProductCard
  },
  model: {
    prop: "position",
    event: "change"
  },
  props: {
    /**
     * IDs of products to add to carousel for showing product recommendations for cross selling
     */
    crossSellProductIds: {
      type: Array,
      default: () => []
    },
    market: {
      type: String,
      default: "US"
    },
    language: {
      type: String,
      default: "en"
    },
    env: {
      type: String,
      default: "test"
    },
    position: {
      type: Number,
      default: 0
    },
    isWholesale: {
      type: Boolean,
      default: false
    },
    /** use-content-source -> can be either CS for contentstack or Equinox, otherwise will pull from contentstack config map configuration */
    useContentSource: {
      type: String,
      default: null
    },
    quantity: {
      type: Number,
      default: 1
    },
    /** okta - okta token for equinox */
    okta: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      positionIndex: this.position || 0,
      ids: this.crossSellProductIds || [],
      windowWidth: null,
      productsData: null,
      translationData: null
    };
  },
  watch: {
    crossSellProductIds: {
      handler() {
        this.ids = this.crossSellProductIds || [];
        this.positionIndex = this.position || 0;
        if (this.ids && this.ids.length > 0) {
          this.getProductsData();
          this.getProductTranslations();
        }
      },
      immediate: true
    },
    position(index) {
      this.positionIndex = index;
    },
    positionIndex(index) {
      this.$emit("change", index);
    }
  },
  created() {
    window.addEventListener("resize", this.screenWidth);
  },
  mounted() {
    this.screenWidth();
    window.addEventListener("load", this.changeButtons());
  },
  destroyed() {
    window.removeEventListener("resize", this.screenWidth);
    window.removeEventListener("load", this.changeButtons());
  },
  methods: {
    screenWidth() {
      this.windowWidth = window.innerWidth;
    },
    changeButtons() {
      const buttons = Array.from(document.querySelectorAll("button"));
      const filteredButtons = buttons?.filter(b =>
        b?.className?.includes("VueCarousel-navigation-button")
      );
      const prev = filteredButtons?.[0];
      const next = filteredButtons?.[1];
      if (prev && next) {
        if (prev && next) {
          prev.innerHTML = `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.792893 8.70711C0.402369 8.31658 0.402369 7.68342 0.792893 7.29289L7.79289 0.292893C8.18342 -0.0976295 8.81658 -0.0976295 9.20711 0.292893C9.59763 0.683418 9.59763 1.31658 9.20711 1.70711L2.91421 8L9.20711 14.2929C9.59763 14.6834 9.59763 15.3166 9.20711 15.7071C8.81658 16.0976 8.18342 16.0976 7.79289 15.7071L0.792893 8.70711Z" fill="#252525"></path></svg>`;
          next.innerHTML = `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.20711 7.29289C9.59763 7.68342 9.59763 8.31658 9.20711 8.70711L2.20711 15.7071C1.81658 16.0976 1.18342 16.0976 0.792893 15.7071C0.402369 15.3166 0.402369 14.6834 0.792893 14.2929L7.08579 8L0.792893 1.70711C0.402369 1.31658 0.402369 0.683417 0.792893 0.292893C1.18342 -0.0976311 1.81658 -0.0976311 2.20711 0.292893L9.20711 7.29289Z" fill="#252525"></path></svg>`;
        }
      } else {
        setTimeout(() => {
          this.changeButtons();
        }, 2000);
      }
    },
    async getProductsData() {
      if (
        this.ids &&
        this.ids.length > 0 &&
        this.market &&
        this.env &&
        this.language
      ) {
        const response = await getProducts(
          this.ids,
          this.market,
          this.language,
          this.useContentSource,
          this.quantity,
          this.okta,
          this.env
        );
        if (response && response.products && response.products.length > 0) {
          const products = await response.products.filter(
            p => p.error === null
          );
          if (products && products.length > 0) {
            this.productsData = products;
          }
        }
      }
    },
    async getProductTranslations() {
      if (this.market && this.env) {
        const response = await getTranslations(
          this.market,
          this.language,
          this.env
        );
        this.translationData = response;
      }
    }
  }
};
